module.exports = __webpack_public_path__ + "static/omnibox-timeline.6870c814.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/omnibox-timeline.png
// module id = 672
// module chunks = 35783957827783